import {} from "src/_common/interfaces/ApiReqRes";
import { createApiCaller, SAGA_ACTIONS } from "src/_config";
import { useApiCall } from "./appApiCallHook";

export function useCommonApi() {
  const callApi = useApiCall();

  return {
    callGetCountries: createApiCaller(callApi, SAGA_ACTIONS.COMMON.COUNTRIES),
    callGetStates: createApiCaller(callApi, SAGA_ACTIONS.COMMON.STATES),
    callGetCities: createApiCaller(callApi, SAGA_ACTIONS.COMMON.CITIES),
    callNewsletterSignup: createApiCaller(callApi, SAGA_ACTIONS.COMMON.NEWSLETTER_SIGNUP),
    callGetGameStatusText: createApiCaller(callApi, SAGA_ACTIONS.COMMON.GET_GAME_STATUS_TEXT),
  };
}
